/**
 * @module メール送信完了確認表示用コンポーネント
 */
import EmailMessenger from '@/components/emailMessenger/EmailMessenger.vue';
import ThanksPageTitle from './ThanksPageTitle.vue';

export default {
  name: 'ThanksEmailConfirmation',
  components: {
    EmailMessenger,
    ThanksPageTitle,
  },
  data(vm) {
    return {
      pageInfo: this.fromPageInfo,
      contents: 0,
      contentsInfo: [
        // ToDo変数名変更
        {
          id: 0,
          page: 52,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.メインユーザー仮登録完了'
          ), //"メインユーザー仮登録完了", // FE-CU54-C0003
          text: vm.$vuetify.lang.t('$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.本登録'), //"●分以内にメール本文に記載されているURLより、本登録を行ってください。", // FE-CU54-C0008
        },
        {
          id: 1,
          page: 4,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.パスワード初期化受付完了'
          ), //"パスワード初期化受付完了", // FE-CU54-C0004
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.パスワード設定'
          ), //"●分以内にメール本文に記載されているURLより、秘密の質問を入力後、新しいパスワードの設定を行ってください。", // FE-CU54-C0009
        },
        {
          id: 2,
          page: 40,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.メインユーザー移譲受付完了'
          ), // "メインユーザー移譲受付完了", // FE-CU54-C0005
          text: vm.$vuetify.lang.t('$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.承認否認操作'), //"●分以内にメール本文に記載されているURLより、承認/否認操作を行ってください。", // FE-CU54-C0010
        },
        {
          id: 3,
          page: 48,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.ユーザー情報変更メールアドレス受付完了'
          ), //"ユーザー情報変更(メールアドレス)受付完了", // FE-CU54-C0020
          text: vm.$vuetify.lang.t('$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.承認否認操作'), //"●分以内にメール本文に記載されているURLより、承認/否認操作を行ってください。", // FE-CU54-C0021
        },
      ],
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        contentsInfo: [
          // ToDo変数名変更
          {
            id: 0,
            page: 52,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.メインユーザー仮登録完了'
            ), //"メインユーザー仮登録完了", // FE-CU54-C0003
            text: vm.$vuetify.lang.t('$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.本登録'), //"●分以内にメール本文に記載されているURLより、本登録を行ってください。", // FE-CU54-C0008
          },
          {
            id: 1,
            page: 4,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.パスワード初期化受付完了'
            ), //"パスワード初期化受付完了", // FE-CU54-C0004
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.パスワード設定'
            ), //"●分以内にメール本文に記載されているURLより、秘密の質問を入力後、新しいパスワードの設定を行ってください。", // FE-CU54-C0009
          },
          {
            id: 2,
            page: 40,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.メインユーザー移譲受付完了'
            ), // "メインユーザー移譲受付完了", // FE-CU54-C0005
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.承認否認操作'
            ), //"●分以内にメール本文に記載されているURLより、承認/否認操作を行ってください。", // FE-CU54-C0010
          },
          {
            id: 3,
            page: 48,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.ユーザー情報変更メールアドレス受付完了'
            ), //"ユーザー情報変更(メールアドレス)受付完了", // FE-CU54-C0020
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.承認否認操作'
            ), //"●分以内にメール本文に記載されているURLより、承認/否認操作を行ってください。", // FE-CU54-C0021
          },
        ],
      };
    },
  },
  props: {
    fromPageInfo: {
      type: Object,
      default: { page: 4 },
      require: false,
    },
  },
  mounted: function () {
    let page = this.pageInfo.page;
    let cont = 0;
    this.contentsInfo.forEach(function (item) {
      if (item.page == page) {
        cont = item.id;
      }
    });
    this.contents = cont;
  },
};
